<template>
  <div class="b-filters-wrap">
    <div class="b-filters">
      <CalendarSliderByServerData
        v-if="hasDates"
        :model-value="selectedFilters.dates"
        :dates="filters['dates']"
        :filtered="filtersDataFiltered['dates']"
        :mini-calendar="true"
        :local="locale"
        @filter-changed="updateSelectedFilters"></CalendarSliderByServerData>

      <div v-if="filtersHaveValues" class="b-filters__title">
        {{ whereDoYouWant }}
      </div>
      <AgnosticFilterList
        v-if="filtersHaveValues"
        class="b-filters__holder"
        :placeholders="placeholders"
        :selected-filters="currentSelection"
        :show-filters="showFilters"
        :filters="filtersDataFiltered"
        @filter-changed="updateSelectedFilters"></AgnosticFilterList>
    </div>
    <div v-if="hasGenres" class="b-filters">
      <div class="b-filters">
        <div class="b-filters__title">
          {{ whatDoYouWant }}
        </div>
        <div class="b-filters__holder">
          <GenresCheckboxes
            :model-value="currentSelection['genres']"
            :all-genres="allGenres"
            :all-filters="filters['genres']"
            :filtered="filtersDataFiltered['genres']"
            @filter-changed="updateSelectedFilters"></GenresCheckboxes>
        </div>

        <button
          type="button"
          class="btn-cta b-filters__clear-all"
          @click="toClearFilters">
          {{ clearFilters }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import AgnosticFilterList from './AgnosticFilterList.vue'
import GenresCheckboxes from './GenresCheckboxes.vue'
import CalendarSliderByServerData from '../components/CalendarSliderByServerData.vue'
import { getLocale } from '../../lib/lib'
import { applyFilters } from '../../lib/filtering'

export default {
  components: {
    AgnosticFilterList,
    GenresCheckboxes,
    CalendarSliderByServerData,
  },
  props: {
    whereDoYouWant: {
      default: 'Where would you like',
      type: String,
    },
    whatDoYouWant: {
      default: 'What would you like',
      type: String,
    },
    clearFilters: {
      default: 'Clear filters',
      type: String,
    },
    allGenres: {
      default: 'All genres',
      type: String,
    },
    filters: {
      default() {
        return {}
      },
      type: Object,
    },
    selectedFilters: {
      default() {
        return {}
      },
      type: Object,
    },
    showFilters: {
      default() {
        return []
      },
      type: Array,
    },
    placeholders: {
      default() {
        return []
      },
      type: Array,
    },
    hasDates: {
      default: true,
      type: Boolean,
    },
    hasGenres: {
      default: true,
      type: Boolean,
    },
  },
  emits: ['filterChanged', 'resetFilters'],

  data() {
    return {
      filtersDataFiltered: { ...this.filters },
      currentSelection: { ...this.selectedFilters },
      // genreFilters: [...this.selectedFilters.genres],
      lastFilteredData: {
        cinemas: {},
        genres: {},
        roomTypes: {},
        screenTypes: {},
      },
      locale: getLocale(),
    }
  },
  computed: {
    modelValue() {
      return this.selectedFilters.dates?.length > 0
        ? this.selectedFilters.dates
        : ''
    },

    filtersHaveValues() {
      return (
        this.filtersDataFiltered[this.showFilters[0]]?.length > 0 ||
        this.filtersDataFiltered[this.showFilters[1]]?.length > 0 ||
        this.filtersDataFiltered[this.showFilters[2]]?.length > 0
      )
    },
  },
  watch: {
    selectedFilters: {
      handler(newVal) {
        this.currentSelection = { ...newVal }
      },
    },
  },
  created() {
    if (this.hasDates) {
      this.updateSelectedFilters(this.selectedFilters.dates, 'dates', false)
    }
  },

  mounted() {
    this.setFiltersByParams()
  },

  methods: {
    setFiltersByParams() {
      const rawParams = new URLSearchParams(window.location.search)
      const params = {}
      for (const [key, value] of rawParams.entries()) {
        params[key.toLowerCase()] = value.toLowerCase()
      }

      const screenTypeParam = params['screentype']

      if (screenTypeParam) {
        const selected = this.filtersDataFiltered.roomTypes.find(
          (item) => item.display.toLowerCase() === screenTypeParam
        )

        if (selected) {
          this.currentSelection.roomTypes = selected.value
        }
      }
    },

    toClearFilters() {
      this.$emit('resetFilters')
    },
    updateSelectedFilters(filters, key, scroll = true) {
      for (const k in filters) {
        if (k !== 'genres' && k !== 'dates') {
          this.currentSelection[key] = filters[key]
        }
      }
      if (key === 'genres') {
        this.currentSelection['genres'] = [...filters]
      }
      if (key === 'dates') {
        this.currentSelection['dates'] = filters
      }

      this.$nextTick(() => {
        this.checkFilters(key)

        this.$nextTick(() => {
          this.$emit('filterChanged', this.currentSelection, scroll)
        })
      })
    },
    checkFilters(key) {
      if (key !== 'genres') {
        this.setFiltersByKey(key)
      } else {
        this.setFiltersByGenres()
      }
    },

    setFiltersByKey(key) {
      if (this.currentSelection[key] !== 'All') {
        const selectedFilter = JSON.parse(
          JSON.stringify(
            this.filters[key].find(
              (item) => item.value === this.currentSelection[key]
            )
          )
        )

        this.lastFilteredData[key] = JSON.parse(
          JSON.stringify(selectedFilter.filters)
        )

        this.filtersDataFiltered = applyFilters(
          this.filters,
          this.lastFilteredData
        )

        const filteredGenres = this.filtersDataFiltered['genres'].map(
          (item) => item.value
        )

        // deselect current selection of genres based on rest filters
        this.currentSelection['genres'] = this.selectedFilters['genres'].filter(
          (genre) => {
            return filteredGenres.includes(genre)
          }
        )
        // if(filteredGenres.length < this.filters["genres"].length && this.selectedFilters["genres"].length){

        // }
      } else {
        this.lastFilteredData[key] = undefined
        for (const filterKey in this.lastFilteredData) {
          if (filterKey !== key) {
            this.filtersDataFiltered = applyFilters(
              this.filters,
              this.lastFilteredData
            )
          }
        }
      }
    },

    setFiltersByGenres() {
      const key = 'genres'

      if (this.currentSelection[key].length) {
        const selectedFilters = this.filters[key]
          .filter((item) => this.currentSelection[key].includes(item.value))
          .map((item) => item.filters)

        const selectedFilter = {
          cinemas: [
            ...new Set(selectedFilters.map((item) => item.cinemas).flat()),
          ],
          roomTypes: [
            ...new Set(selectedFilters.map((item) => item.roomTypes).flat()),
          ],
          screenTypes: [
            ...new Set(selectedFilters.map((item) => item.screenTypes).flat()),
          ],
        }

        this.lastFilteredData[key] = selectedFilter

        this.filtersDataFiltered = applyFilters(
          this.filters,
          this.lastFilteredData
        )
      } else {
        this.lastFilteredData[key] = undefined
        for (const filterKey in this.lastFilteredData) {
          if (filterKey !== key) {
            this.filtersDataFiltered = applyFilters(
              this.filters,
              this.lastFilteredData
            )
          }
        }
      }
    },
  },
}
</script>
